import React from 'react';

import { useAppContext } from '../../contexts/AppContext';
import useServerSideRendering from '../../hooks/useServerSideRendering';
import { getImgxSrc } from '../../utils/images';
import Button from '../BaseUI/Button';
import { EventProp } from './TimeLine';

const HorizontalTimePoint = ({ events }: { events: EventProp[] }) => {
  const { env } = useAppContext();
  const hydrated = useServerSideRendering();
  const firstEvent = events[0];
  const secondEvent = events[1];

  return (
    <div className="w-full border-0 border-b-2 border-solid h-[200px] relative border-gray-200">
      <div>
        {hydrated && (
          <img
            className="max-w-[200px] absolute left-[10rem]"
            src={getImgxSrc({
              path: firstEvent.logoPath,
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="w-full max-w-[260px] absolute top-[4rem] left-[16rem]">
          <Button
            variant="link"
            className="font-serif text-button-lg sm:text-[22px] sm:leading-8 underline leading-6 text-left tracking-normal"
            href={firstEvent.articleLink}
          >
            “{firstEvent.articleTitle}”
          </Button>
        </div>
        {hydrated && (
          <img
            className="absolute top-72 left-[14rem]"
            src={getImgxSrc({
              path: 'brand_campaign/pinRed.svg',
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="absolute -bottom-48 left-[12rem] text-pro-red font-sans text-body-sm font-bold uppercase">
          {firstEvent.month} {firstEvent.year}
        </div>
      </div>
      <div>
        {hydrated && (
          <img
            className="max-w-[150px] absolute right-[8rem]"
            src={getImgxSrc({
              path: secondEvent.logoPath,
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="w-full max-w-[260px] text-[16px] font-serif leading-6 sm:leading-6 absolute top-[4rem] -right-[3rem]">
          “{secondEvent.articleTitle}”
        </div>
        {hydrated && (
          <img
            className="absolute top-72 right-[14rem]"
            src={getImgxSrc({
              path: 'brand_campaign/pinGray.svg',
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
      </div>
      <div className="absolute -bottom-48 right-[12rem] font-sans text-body-sm font-bold uppercase">
        {secondEvent.month} {secondEvent.year}
      </div>
    </div>
  );
};

export default HorizontalTimePoint;
